exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host /deep/ .calendar {\n    max-width: 200px;\n}\n\n:host /deep/ .calendar input{\n    width: 100%;\n    text-align: center;\n}\n\n:host/deep/ .unconformities-only {      \n}\n\n.ui-datatable table{\n    width: auto !important;\n}\n\n@media only screen and (min-width: 1026px) {\n    :host /deep/ .checklist {\n    }\n\n    :host/deep/ .unconformities-only {\n        margin-top: 25px;\n        min-width: 185px;\n    }\n\n    :host /deep/ .filter-button {\n        max-width: 130px;\n    }\n}\n\n.checkboxContainer {\n    padding: 8px\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/report/checklist-answered/checklist-answered.component.css
// module id = ../../../../../src/app/report/checklist-answered/checklist-answered.component.css
// module chunks = main